import { PagosService } from './src/services/pagos.services';

export type { OrdenCompra, GrupoProducto, Producto, PagoOrdenCompra } from './src/services/suite.interfaces';

export const pagosService = new PagosService();

export default pagosService;
